import React, { useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import UnitAction from '../actions/UnitAction'
import UnitItem from '../dto/UnitItem'
import i18n from 'simple-react-i18n'
import { push } from '@lagunovsky/redux-react-router'
import {
    PATH_REFERENCIAL,
    PATH_REFERENCIAL_UNIT_ENTITY,
    PATH_REFERENCIAL_UNIT_ENTITY_NEW,
} from '../../../../home/constants/RouteConstants'
import { sandreUnitAllLink } from '../../../../conf/SieauConstants'
import HomeAction from '../../../../home/actions/HomeAction'
import { getReferencialData, reloadJobSync } from '../../../util/ReferencialUtils'
import logoSandre from 'assets/pictures/logo_sandre.png'
import ReferencialAction from '../../../action/ReferencialAction'
import { getDataWithHeaders } from 'utils/ExportDataUtil'
import useTitle from 'utils/customHook/useTitle'
import useActions from 'utils/customHook/useActions'
import {
    nbPerPageLabel,
    REFERENCIAL_TYPE_NAME,
    REFERENTIAL_JOBSYNC_ID,
} from 'referencial/constants/ReferencialConstants'
import useSessionStorage from 'utils/customHook/useSessionStorage'
import JobSyncStatus from '../../JobSyncStatus'
import Input from 'components/forms/Input'
import Select from 'components/forms/Select'
import { Button, Card, CardContent, Grid2, Stack } from '@mui/material'
import { hasValue } from 'utils/NumberUtil'
import { searchAllCharacters } from 'utils/StringUtil'
import { CardTitle } from 'components/card/NewCard'
import { CardTable } from 'components/datatable/NewTable'

const headers = ['code', 'name', 'symbol', 'status']

const UnitsApp = () => {
    const {
        units,
        referencialStatus,
    } = useSelector(store => ({
        units: store.UnitReducer.units,
        referencialStatus: store.ReferencialReducer.referencialStatus,
    }), shallowEqual)

    const [filter, setFilter] = useSessionStorage(`referencial_${REFERENCIAL_TYPE_NAME.unit}`, {})
    const [filterTmp, setFilterTmp] = useState(filter)
    const [jobSync, setJobSync] = useState(undefined)

    useEffect(() => {
        reloadJobSync(REFERENTIAL_JOBSYNC_ID.unit, setJobSync)
    }, [])

    useEffect(() => {
        if (jobSync && jobSync.executions[0]) {
            if (!jobSync.executions[0].statusCode) {
                setTimeout(() => {
                    reloadJobSync(REFERENTIAL_JOBSYNC_ID.unit, setJobSync)
                }, 5000)
            }
        }
    }, [jobSync])

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(UnitAction.fetchUnits(true))
        dispatch(HomeAction.setHelpLink('', ''))
        if (!referencialStatus.length) {
            dispatch(ReferencialAction.fetchReferencialStatus())
        }
    }, [])

    useTitle(() => [{
        title: i18n.referencials,
        href: PATH_REFERENCIAL,
    }, {
        title: i18n.referenceUnit,
        href: PATH_REFERENCIAL_UNIT_ENTITY,
    }], [])

    const unitItems = useMemo(() => units.map(u => new UnitItem(u)), [units])
    const unitsByStatus = useMemo(() => hasValue(filter.status) ? unitItems.filter(h => parseInt(h.status) === filter.status) : unitItems, [filter.status, unitItems])
    const referencialData = useMemo(() => getReferencialData(unitsByStatus), [unitsByStatus])
    const data = useMemo(() => {
        return referencialData
            .filter((obj) => searchAllCharacters(headers.map((key) => obj[key]).join())
                .includes(searchAllCharacters(filter.searchValue || '')))
    }, [referencialData, filter])

    useActions(() => {
        return {
            new: () => dispatch(push(PATH_REFERENCIAL_UNIT_ENTITY_NEW)),
            referencialActions: {
                actions: {
                    export: {
                        data: getDataWithHeaders(data, headers),
                        titleFile: i18n.unitsList,
                    },
                    sync: {
                        updateAction: options => dispatch(ReferencialAction.launchSyncJob(REFERENTIAL_JOBSYNC_ID.unit, options, () => reloadJobSync(REFERENTIAL_JOBSYNC_ID.unit, setJobSync))),
                        withInsertAllOption: true,
                    },
                    purge: {
                        onPurge: () => dispatch(UnitAction.purgeUnit()),
                    },
                },
            },
            links: [{
                href: sandreUnitAllLink,
                img: logoSandre,
                label: i18n.sandre.toUpperCase(),
            }],
        }
    }, [data])

    const colorData = useMemo(() => data.map(u => {
        const obj = {}
        Object.keys(u).map(key => {
            obj[key] = Object.assign({}, { value: u[key] })
        })
        obj.id = u.id
        obj.colorLine = u.active === '1' ? undefined : '#c5c5c5'
        return obj
    }).sort((a, b) => parseInt(a.code.value) - parseInt(b.code.value)), [data])

    return (
        <Stack margin={1} spacing={1}>
            <Card>
                <CardTitle title={i18n.criterias} color='bannerColor'/>
                <CardContent>
                    <Grid2 size={12} container spacing={1} paddingTop={1}>
                        <Grid2 size={3}>
                            <Input
                                title={i18n.search}
                                value={filterTmp.searchValue}
                                onChange={v => setFilterTmp({ ...filterTmp, searchValue: v })}
                                onEnterKeyPress={() => setFilter({ ...filterTmp })}
                            />

                        </Grid2>
                        <Grid2 size={3}>
                            <Select
                                options={referencialStatus}
                                label={i18n.status}
                                onChange={v => setFilterTmp({ ...filterTmp, status: v })}
                                value={filterTmp.status}
                                nullLabel='&nbsp;'
                            />
                        </Grid2>
                        <Grid2 size={5}>
                            <JobSyncStatus jobSync={jobSync}/>
                        </Grid2>
                        <Grid2 size={1} paddingTop={2}>
                            <Button className='right' onClick={() => setFilter({ ...filterTmp })} variant='contained' color='primary'>
                                {i18n.search}
                            </Button>
                        </Grid2>
                    </Grid2>
                </CardContent>
            </Card>
            <CardTable
                title={i18n.unitsList}
                rowsPerPageOptions={nbPerPageLabel}
                color='bannerColor'
                rows={colorData}
                headers={ headers }
                onClickRow={unit => dispatch(push(`/referencial/unit/${unit.id}/dashboard`))}
            />
        </Stack>
    )
}

export default UnitsApp
